import SideBarTypes from './constants'

export const SidebarRequest = (postData, callback) => {  
  return {
    type: SideBarTypes.REQUESTING,
    payload: postData,
    callback,
  }
}

export const SidebarRequestSuccess = (data) => {
  return {
    type: SideBarTypes.SUCCESS,
    payload: data,
  }
}

export const SidebarRequestError = (error) => {
  return {
    type: SideBarTypes.ERROR,
    payload: error,
  }
}


// WEBPACK FOOTER //
// ./src/components/Sidebar/actions.js